import { PageHero } from "../components/Shared";
import { Reveal } from "../components/Reveal";
import { useTitle } from "../lib/useTitle";

const SECTIONS = [
  {
    title: "Information We Collect",
    body: "When you contact us, apply to the program, submit a referral, RSVP to an event, volunteer, or join our email community, we collect the information you choose to share — such as your name, email address, phone number, and the content of your message or application. We do not collect payment information on this website; donations are processed securely by our external giving platform.",
  },
  {
    title: "How We Use Your Information",
    body: "We use your information only to respond to your inquiry, process applications and referrals, coordinate volunteer service and event participation, and — if you sign up — send community updates you can unsubscribe from at any time. We never sell, rent, or trade your personal information.",
  },
  {
    title: "Confidentiality of Participant Information",
    body: "As a healing program serving women who have experienced trauma, we treat participant applications and referrals with heightened confidentiality. Access is limited to team members directly coordinating care, and information is shared with collaborating professionals only with the participant's explicit consent, except where required by law to prevent harm.",
  },
  {
    title: "Data Retention & Security",
    body: "We retain submissions only as long as needed to serve you and fulfill legal or reporting obligations, and we use reasonable administrative and technical safeguards to protect them. No method of transmission over the internet is perfectly secure, but protecting your trust is central to our mission.",
  },
  {
    title: "Your Choices",
    body: "You may request a copy, correction, or deletion of your personal information at any time by contacting us through our Contact page. Email community members can unsubscribe via the link in any message.",
  },
  {
    title: "Changes to This Policy",
    body: "We may update this policy as our program grows. The current version will always be posted on this page.",
  },
];

export default function Privacy() {
  useTitle("Privacy Policy | Bee Courageous @ Garden Grub");
  return (
    <>
      <PageHero
        eyebrow="Privacy Policy"
        lines={["Your trust,", "carefully kept."]}
        lede="How Bee Courageous @ Garden Grub collects, uses, and protects the information you share with us."
      />
      <section className="mx-auto max-w-3xl px-4 py-20 sm:px-6 lg:py-28" data-testid="privacy-content">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-charcoal/50">Last updated: July 2026</p>
        <div className="mt-8 space-y-10">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={0.04 * i}>
              <h2 className="font-serif text-2xl font-semibold text-charcoal">{i + 1}. {s.title}</h2>
              <p className="mt-3 text-sm leading-relaxed text-charcoal/75 sm:text-base">{s.body}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
